// https://react.semantic-ui.com/

import _ from 'lodash';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, Tab, Icon, Modal, Loader, Header, Popup, Divider, Table, Grid, Form, Segment, Input, Label, Pagination, Menu, Dimmer, Image, Search, Message } from 'semantic-ui-react';
import { TechnicsReportShort } from './components/technics_report_short.js';
import ButtonAllHistory from './components/button_all_history.js';
import PlateAttach from './components/plate_attach.js';
import GeneralSearch from './components/general_search.js';
import EstimateButton from './components/estimate_button.js';
import CarImage from './components/car_image.js';
import PriceAnalysis from './components/price_analysis.js';
import FormInput from './components/form_input.js';
import FormElementLogin from './components/form_element_login.js';
import FormElementRegister from './components/form_element_register.js';
import LoginForm from './components/login_form.js';

if (!document.getElementById("loading-screen")) {
	
	window["selectedVirtual"] = {
		key: "jfi43ufh93gh3hg39f4j",
		showing_car: 61346,
		date: 201410,
		km: 50000
	};
	
	Array.prototype.intersect = function(arr)
	{
		return this.filter(x => arr.includes(x));
	};
	
	Array.prototype.magnet = function (from, to)
	{
		let item = this[from];
		
		this.splice(from, 1);
		this.splice(to + (to > from ? 0 : 1), 0, item);
	};
	
	Number.prototype.formatMoney = function(n, s, c) {
		var x = 3,
		    re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
		    num = this.toFixed(Math.max(0, ~~n));
		
		return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
	};
	
	window["ContentEditable"] = function() { console.log("contentEditable"); };
	
	window["Service"] = new function()
	{
		this.Post = function(action, parameters, callback)
		{
			const xhr = new XMLHttpRequest();
			
			xhr.onreadystatechange = function()
			{
				if (this.readyState == 4 && this.status == 200)
				{
					const response = JSON.parse(this.responseText);
					
					callback(response);
				}
			};
			
			xhr.open("POST", "http://localhost/api/v1.0/", true);
			xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			xhr.send("key=" + selectedVirtual.key + "&action=" + action + parameters);
		};
	};
}

// 0: Obligatory
// 1: Exclude
// 2: Included
// pack = [
// 	{
// 		code: 60101
// 		inpack: [55839, 58756, 76585, 76613]
// 	}
// ]
// relation = [
// 	{
// 		code: 60103,
// 		formula: "76637AND(76634OR56910)AND60100",
// 		inrelation: [ 76634, 76637, 56910 ],
// 		relation: 2
// 	}
// ]

const OptEqContext = React.createContext();

function OptEqContent(props, context) {
	
	var rows = [], id = props.id ? props.id : "", title = props.title ? props.title : text.extraEquipment;
	
	const locked = props.locked;
	
	const opentag = props.opentag;
	
	var equip = props.equip;
	
	if (!props.equip)
	{
		equip = context.equipment;
	}
	
	for (var i = 0; i < equip.length; i++)
	{
		const e = equip[i];
		
		rows.push(<OptEqElement key={e.code} equip={e} id={id} opentag={opentag} locked={locked} />);
	}
	
	const className = locked ? "car-report table-main table-collapse-simple expand" : "car-report";
	
	id = props.id ? "car-report-" + props.id + "-equipment" : "car-report-extra-equipment";
	
	if (!locked)
	{
		return <table className={className} id={id}><tbody>{rows}</tbody></table>;
	}
	else if (equip.length > 0)
	{
		if (typeof TableCollapseSimpleAttachListeners === "function")
		{
			setTimeout(function () {
				
				TableCollapseSimpleAttachListeners();
				
			}, 300);
		}
		
		return (
			<table className={className} id={id}>
				<thead>
					<tr>
						<td colSpan="4" style={{ width: "2000px", border: 0 }}>{title}</td>
					</tr>
				</thead>
				<tbody>{rows}</tbody>
			</table>
		);
	}
	else
	{
		return "";
	}
}

class OptEqElement extends React.Component {
	
	constructor(props) {
		
		super(props);
	}
	
	static contextType = OptEqContext;
	
	render() {
		
		const locked = this.props.locked ? true : false;
		
		const checked = this.props.equip.checked && !locked ? "checked" : "";
		
		const className = checked;
		
		var groupButton = "";
		
		if (this.props.equip.ispack)
		{
			let inpack = [];
			
			if (this.context && this.context.pack && this.context.pack.length > 0)
			{
				inpack = this.context.pack.filter(x => x.code == this.props.equip.code);
				
				if (inpack.length > 0)
				{
					inpack = inpack[0].inpack
				}
				else
				{
					inpack = [];
				}
			}
			
			const equipmentContent = this.context ? this.context.equipment.filter(x => inpack.includes(x.code)) : [];
			
			const content = equipmentContent.length > 0 ? equipmentContent : text.noPackageContent;
			
			groupButton = <Button compact circular size="mini" style={{ marginLeft: "10px" }} icon="list" />;
			
			groupButton =
				<Popup hideOnScroll position="top center" wide="very" trigger={groupButton}>
					{Array.isArray(content) ? (
						<Popup.Content>
							<Header>{text.packageContents}:</Header>
							<OptEqContent equip={content} id="basic" />
						</Popup.Content>
					) : (
						<Popup.Content>{content}</Popup.Content>
					)}
				</Popup>;
		}
		
		const clickEvent = this.props.opentag == "opteq" ? optEqOpen : (this.context ? this.context.openPrice : ()=>{});
		
		const click = locked ? clickEvent : (this.context ? this.context.clickOptEq : ()=>{});
		
		if (this.props.id == "")
		{
			const price = this.props.equip.price.formatMoney(0, ".", ",") + text.cur;
			
			const ordercode = this.props.equip.manmcode != null ? this.props.equip.manmcode.substring(0, 3) : "";
			
			return (
				<tr className={className} onClick={click} code={this.props.equip.code}>
					<td>
						<input type="checkbox" checked={checked || locked}
							readOnly disabled={locked ? true : false}
						/>
					</td>
					<td>{ordercode}</td>
					<td>{this.props.equip.label}{groupButton}</td>
					<td>{price}</td>
				</tr>
			);
		}
		else
		{
			return <tr><td>{this.props.equip.label}{groupButton}</td></tr>;
		}
	}
}

class OptEq extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			error: false,
			loading: true,
			errorOnSave: false,
			optEqSaved: 0,
			modalOpen: false,
			locked: false,
			code: 0,
			pack: [],
			relation: [],
			equipment: [],
			categories: [],
			savedEquipment: ""
		};
		
		this.load = this.load.bind(this);
		this.callbackRequest = this.callbackRequest.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.handleSaveBeforeClose = this.handleSaveBeforeClose.bind(this);
		this.callbackRequestOnConfirm = this.callbackRequestOnConfirm.bind(this);
		this.callbackRequestOnConfirmError = this.callbackRequestOnConfirmError.bind(this);
		this.onSaveErrorDismiss = this.onSaveErrorDismiss.bind(this);
		this.click = this.click.bind(this);
	}
	
	componentDidMount() {
		
		window["optEqUpdate"] = () => { this.forceUpdate() };
		
		window["optEqGetGlobalObj"] = () => {
			
			const { pack, equipment } = this.state;
			
			const openPrice = typeof priceConfiguratorOpen === "function" ? priceConfiguratorOpen : false;
			
			return {
				pack: pack,
				equipment: equipment,
				openOptEq: this.handleOpen,
				openPrice: openPrice,
				clickOptEq: this.click
			};
		};
		
		window["optEqCallbackRequest"] = (response) => {
			
			this.callbackRequest(response);
			
			this.load();
		};
		
		window["optEqOpen"] = () => {
			
			this.setState({ modalOpen: true });
		};
		
		window["optEqCallbackRequestOnConfirm"] = () => { this.callbackRequestOnConfirm() };
		
		window["optEqCallbackRequestOnConfirmError"] = () => { this.callbackRequestOnConfirmError() };
		
		window["optEqCallbackRequestOnLoad"] = (state) => {
			
			const locked = !(typeof carSaveInfoProps != "undefined" && carSaveInfoProps.editcode);
			
			if (state == "")
			{
				this.setState({ loading: false, locked }, () => this.callbackRequestOnConfirm());
			}
			else
			{
				let { optEq, UpdateOptEqPrice } = this.props;
				
				if (optEq == 0 && state.equipment.length > 0)
				{
					state.equipment.map(e => optEq = this.equipmentPriceChange(e, optEq));
				}
				
				UpdateOptEqPrice(optEq);
				
				var equip = this.state.equipment;
				
				if (equip.length == 0)
				{
					this.setState(
						{ loading: false, equipment: state.equipment, locked },
						() => this.callbackRequestOnConfirm()
					);
				}
				else
				{
					// Case admin can always edit restore selected equipments
					if (typeof state.equipment[0].code !== "undefined")
					{
						const codes = equip.map(e => e.code);
						
						state.equipment.forEach(e => {
						
							const index = codes.indexOf(e.code);
							
							equip[index].checked = true;
						});
					}
					else
					{
						// Case that equipments are from old valuation and does not have code
						const labels = equip.map(e => e.label);
						
						state.equipment.forEach(e => {
						
							const index = labels.indexOf(e.label);
							
							equip[index].checked = true;
						});
					}
					
					this.setState(
						{ loading: false, equipment: equip },
						() => this.callbackRequestOnConfirm()
					);
				}
			}
		};
		
		if (!document.getElementById("loading-screen")) this.load();
		else if (typeof carSaveInfoProps != "undefined" && carSaveInfoProps.editcode) this.load();
	}
	
	load() {
		
		if (!document.getElementById("loading-screen"))
		{
			Service.Post(
				"action_get_configurator_data",
				"&code=" + selectedVirtual.showing_car +
				"&date=" + selectedVirtual.date +
				"&km=" + selectedVirtual.km +
				"&origin=popup",
				this.callbackRequest
			);
		}
		else if (typeof carSaveInfoProps != "undefined" && carSaveInfoProps.editcode && this.state.equipment.length == 0)
		{
			// Load configurator data
			
			carConfiguratorRequest = new ActionRequest(
				"action_get_configurator_data", { selection: selected }
			);
			
			carConfiguratorRequest.Success = this.callbackRequest;
			
			carConfiguratorRequest.Fail = this.callbackRequest;
			
			carConfiguratorRequest.Trigger();
		}
	}
	
	callbackRequest(response) {
		
		//console.log(response);
		
		if (typeof response !== "undefined" && response && response.data)
		{
			response = response.data;
		}
		
		if (typeof response === "undefined" || !response || !response.code)
		{
			this.setState({ error: true, locked: true, loading: false });
			
			if (!document.getElementById("loading-screen"))
			{
				console.error("Given car is not charged on user.");
			}
			
			return false;
		}
		
		this.setState({
			loading: false,
			code: response.code,
			pack: response.pack,
			relation: response.relation,
			equipment: response.extraEquipment,
			categories: response.categories
		});
		
		/*if (optEqSelectedTmp != "")
		{
			optEqCallbackRequestOnLoad(optEqSelectedTmp);
		}*/
		
		this.callbackRequestOnConfirm();
	}
	
	callbackRequestOnConfirm() {
		
		const { equipment } = this.state;
		
		const { optEq } = this.props;
		
		if (typeof PriceAnalysisSetOptEqPrice === "function")
		{
			PriceAnalysisSetOptEqPrice(optEq);
		}
		
		if (typeof OptEqSelectedSetEquipment === "function")
		{
			OptEqSelectedSetEquipment(equipment.filter(e => e.checked));
		}
		
		this.handleClose();
	}
	
	callbackRequestOnConfirmError() {
		
		this.setState({ loading: false, errorOnSave: true });
		
		setTimeout(this.onSaveErrorDismiss, 2000);
	}
	
	category(category) {
		
		const { equipment, categories } = this.state;
		
		if (categories.length == 0)
		{
			return equipment;
		}
		
		return equipment.filter((e) =>
			e.category.intersect(categories[category]).length > 0 && e.flag == 2
		);
	}
	
	other() {
		
		var categories = [];
		
		for (var c in this.state.categories)
		{
			categories = categories.concat(this.state.categories[c]);
		}
		
		return this.state.equipment.filter(function(e) {
			return e.category.intersect(categories).length == 0 && e.flag == 2;
		});
	}
	
	handleOpen() {
		
		const { error, locked, equipment } = this.state;
		
		if (!error && !locked && equipment.length > 0)
		{
			this.setState({
				modalOpen: true,
				optEqSaved: this.props.optEq,
				savedEquipment: JSON.stringify(equipment)
			});
		}
		else if (equipment.length > 0)
		{
			this.setState({ error: false });
			
			this.load();
		}
	}
	
	handleClose = () => this.setState({
		modalOpen: false,
		loading: false,
		savedEquipment: "",
		optEqSaved: 0
	});
	
	handleCancel() {
		
		let { optEqSaved, savedEquipment } = this.state;
		
		const { UpdateOptEqPrice } = this.props;
		
		try {
			savedEquipment = JSON.parse(savedEquipment);
		} catch (e) {
			savedEquipment = [];
		}
		
		this.setState({ equipment: savedEquipment });
		
		UpdateOptEqPrice(optEqSaved);
		
		this.handleClose();
	}
	
	handleSaveBeforeClose() {
		
		if (!document.getElementById("loading-screen"))
		{
			setTimeout(this.callbackRequestOnConfirm, 500);
		}
		else if (carSaveInfoProps.editcode)
		{
			const { equipment } = this.state;
			
			const { price, optEq, priceConfig } = this.props;
			
			const state = {
				equipment: equipment.filter(e => e.checked)
			};
			
			carSaveInfoProps.type = "opt_eq";
			carSaveInfoProps.content = state;
			carSaveInfoProps.price = price + optEq + priceConfig;
			
			optEqSaveInfoRequest.Trigger();
			
			const svgPriceLabel = document.getElementById("svg-price-label");
			
			if (svgPriceLabel)
			{
				svgPriceLabel.innerHTML = price + optEq + priceConfig + text.cur;
			}
		}
		else
		{
			window.alert(text.carNotEditable);
			
			this.setState({ loading: false });
			
			return;
		}
		
		this.setState({ loading: true });
	}
	
	onSaveErrorDismiss() {
		
		this.setState({ errorOnSave: false });
	}
	
	equipmentPriceChange(e, optEq) {
		
		if (e.checked == true)
		{
			optEq += e.price;
		}
		else
		{
			optEq -= e.price;
		}
		
		return optEq;
	}
	
	click(e) {
		
		let { equipment, relation } = this.state;
		
		let { optEq, UpdateOptEqPrice } = this.props;
		
		e.stopPropagation();
		
		const code = parseInt(GetAttributeFromEvent(e, "code"));
		
		if (!code)
		{
			return;
		}
		
		const id = equipment.map(x => x.code).indexOf(code);
		
		if (equipment[id].checked == true)
		{
			delete equipment[id].checked;
		}
		else
		{
			equipment[id].checked = true;
		}
		
		optEq = this.equipmentPriceChange(equipment[id], optEq);
		
		/**
		 * @todo CONTINUE to make relations here
		 */
		
		//const equipmentRelations = relation.filter(x => x.code == code);
		
		UpdateOptEqPrice(optEq);
		
		this.setState({ equipment });
	}
	
	render() {
		
		let {
			error, errorOnSave, modalOpen, locked, equipment, savedEquipment, code, pack, loading
		} = this.state;
		
		let { price, optEq, priceConfig } = this.props;
		
		const modal = modalOpen, handle = this.handleClose;
		
		loading = loading || (code == 0 && price == 0 && !error);
		
		price = (price + optEq + priceConfig).formatMoney(0, ".", ",") + text.cur;
		
		const hasChanges =
			JSON.stringify(equipment) != savedEquipment;
		
		let buttonConfirm =
			<Button disabled={!hasChanges || loading} color="green" onClick={this.handleSaveBeforeClose}
				labelPosition="right" icon="right chevron" content={price} style={{ marginRight: "7px" }}
				className="right floated" loading={loading} />
		
		buttonConfirm = <Popup trigger={buttonConfirm} size="small" content={text.errorOnSave}
			open={errorOnSave} />
		
		const openPrice = typeof priceConfiguratorOpen === "function" ? priceConfiguratorOpen : false;
		
		const globalObj = {
			pack: pack, equipment: equipment, clickOptEq: this.click, openPrice: openPrice
		};
		
		let paneEq = [];
		
		if (!locked)
		{
			paneEq = [
				{
					title: text.category1,
					equipment: this.category("exterior")
				},
				{
					title: text.category2,
					equipment: this.category("interior")
				},
				{
					title: text.category3,
					equipment: this.category("navigator")
				},
				{
					title: text.rims,
					equipment: this.category("rims")
				},
				{
					title: text.category5,
					equipment: this.category("systems")
				},
				{
					title: text.category6,
					equipment: this.other()
				}
			];
		}
		
		let panes = [];
		
		// Filter panes that have at least one equipment
		for (var i = 0; i < paneEq.length; i++)
		{
			const eq = paneEq[i].equipment;
			
			if (eq.length > 0)
			{
				panes.push({
					menuItem: paneEq[i].title,
					render: () => <OptEqContent equip={eq} />
				});
			}
		}
		
		// Add "all equipment" pane
		panes.push({
			menuItem: text.allEquipment,
			render: () =>
				<OptEqContent equip={this.state.equipment.filter(function(e) {
					return e.flag == 2;
				})} />
		});
		
		const groupButton =
			<Button loading={loading} disabled={loading || locked} basic className="no-print"
				icon={!loading && !error ? "wrench" : "times circle"} onClick={this.handleOpen} color="black"
				compact size="small" content={!error ? "Configurator" : "Error"} />;
		
		const tabMenu = { color: "blue", attached: false, tabular: false, pointing: true };
		
		return (
			<OptEqContext.Provider value={globalObj}>
				<Modal size="large" trigger={groupButton} open={modal} onClose={handle} centered={false}
					className="no-print" closeOnEscape={false} closeOnDimmerClick={!hasChanges}
				>
					<Modal.Header>Configurator</Modal.Header>
					<Modal.Content scrolling>
						<Modal.Description>
							<Tab menu={tabMenu} panes={panes} />
						</Modal.Description>
					</Modal.Content>
					<Modal.Actions style={{ textAlign: "left" }}>
						<Button onClick={this.handleCancel} style={{ marginLeft: "7px" }}>
							<Icon name="times circle" /> {text.cancel}
						</Button>
						{buttonConfirm}
					</Modal.Actions>
				</Modal>
			</OptEqContext.Provider>
		);
	}
}

class PriceConfigurator extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		const value = [
			{
				oper: "minus",
				id: 0,
				label: text.edpr1,
				percent: 0
			},
			{
				oper: "minus",
				id: 1,
				label: text.edpr2,
				percent: 0
			},
			{
				oper: "minus",
				id: 2,
				label: text.edpr3,
				percent: 0
			},
			{
				oper: "minus",
				id: 3,
				label: text.edpr4,
				percent: 0
			},
			{
				oper: "minus",
				id: 4,
				label: text.edpr5,
				percent: 0
			},
			{
				oper: "minus",
				id: 5,
				label: text.edpr6,
				percent: 0
			},
			{
				oper: "plus",
				id: 6,
				label: text.edpr7,
				percent: 0
			}
		];
		
		this.state = {
			startPrice: parseInt(props.price),
			valuation: props.valuation,
			modalOpen: false,
			locked: false,
			loading: 1,
			embeddedModalMinusOpen: false,
			embeddedModalPlusOpen: false,
			embeddedModalState: JSON.stringify({}),
			embeddedButtonValue: 0,
			embeddedFieldError: false,
			embeddedButtonLabelValue: "",
			value: value,
			savedValue: JSON.stringify(value)
		};
		
		this.updatePrice = this.updatePrice.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSaveBeforeClose = this.handleSaveBeforeClose.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleEmbeddedConfirmation = this.handleEmbeddedConfirmation.bind(this);
		this.callbackRequest = this.callbackRequest.bind(this);
		this.callbackRequestOnConfirm = this.callbackRequestOnConfirm.bind(this);
		this.tableRow = this.tableRow.bind(this);
		this.submitOnEnter = this.submitOnEnter.bind(this);
		this.updateButton = this.updateButton.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
	}
	
	componentDidMount() {
		
		window["priceConfiguratorUpdate"] = () => {
			this.forceUpdate();
		};
		
		window["priceConfiguratorOpen"] = () => {
			
			this.handleOpen();
		};
		
		window["priceConfiguratorGetStatus"] = () => {
			
			return { startPrice: this.state.startPrice, value: this.state.value };
		};
		
		window["priceConfiguratorCallbackRequestOnConfirm"] = () => {
			
			this.callbackRequestOnConfirm();
		};
		
		window["priceConfiguratorCallbackRequestOnLoad"] = (state) => {
			
			const locked = !(typeof carSaveInfoProps != "undefined" && carSaveInfoProps.editcode);
			
			if (state == "" || (Array.isArray(state) && state.length == 0))
			{
				this.setState({ loading: false, locked }, () => this.callbackRequestOnConfirm());
			}
			else
			{
				const { startPrice } = this.state;
				
				const { UpdatePriceConfigPrice } = this.props;
				
				const priceConfig = this.updatePrice(state.value) - startPrice;
				
				UpdatePriceConfigPrice(priceConfig);
				
				this.setState(
					{ loading: false, value: state.value, valuation: state.valuation, locked },
					() => this.callbackRequestOnConfirm()
				);
			}
		};
		
		if (!document.getElementById("loading-screen")) this.load();
		else if (typeof carSaveInfoProps != "undefined" && carSaveInfoProps.editcode) this.load();
	}
	
	load() {
		
		if (!document.getElementById("loading-screen"))
		{
			setTimeout(this.callbackRequest, 1000);
		}
		/*else if (carLoadInfoProps.id)
		{}*/
		else
		{
			this.setState({ loading: false });
		}
	}
	
	callbackRequest() {
		
		this.setState({ loading: false });
	}
	
	updatePrice(value) {
		
		var { startPrice, price } = this.state;
		
		if (typeof value === "undefined" || value == null)
		{
			var {value} = this.state;
		}
		
		price = startPrice;
		
		var percent = 0;
		
		value.map(function(v) {
			
			if (v.percent > 0)
			{
				if (v.oper == "minus")
				{
					percent -= v.percent;
				}
				else
				{
					percent += v.percent;
				}
			}
		});
		
		if (percent != 0)
		{
			price += price * (percent / 100);
		}
		
		value.map(function(v) {
			
			if (v.price > 0)
			{
				if (v.oper == "minus")
				{
					price -= v.price;
				}
				else
				{
					price += v.price;
				}
			}
		});
		
		price = Math.round(price);
		
		if (price < 1500)
		{
			price = 1500;
		}
		
		return price;
	}
	
	handleSaveBeforeClose() {
		
		if (!document.getElementById("loading-screen"))
		{
			setTimeout(this.callbackRequestOnConfirm, 1000);
		}
		else if (carSaveInfoProps.editcode)
		{
			const { value, valuation } = this.state;
			
			const { price, optEq, priceConfig } = this.props;
			
			const state = {
				value: value.filter(v => typeof v.percent === "undefined" || v.percent > 0),
				valuation: valuation
			};
			
			carSaveInfoProps.type = "price_config";
			carSaveInfoProps.content = state;
			carSaveInfoProps.price = price + optEq + priceConfig;
			
			priceConfigSaveInfoRequest.Trigger();
			
			const svgPriceLabel = document.getElementById("svg-price-label");
			
			if (svgPriceLabel)
			{
				svgPriceLabel.innerHTML = price + optEq + priceConfig + text.cur;
			}
		}
		else
		{
			window.alert(text.carNotEditable);
			
			this.setState({ loading: false });
			
			return;
		}
		
		this.setState({ loading: 2 });
	}
	
	callbackRequestOnConfirm() {
		
		const { value, startPrice } = this.state;
		
		let percentPlus = 0, percentMinus = 0, pricePlus = 0, priceMinus = 0;
		
		value.map(function(v) {
			
			if (v.percent > 0)
			{
				if (v.oper == "minus")
				{
					percentMinus += v.percent;
				}
				else
				{
					percentPlus += v.percent;
				}
			}
		});
		
		if (percentPlus != 0)
		{
			pricePlus += startPrice * (percentPlus / 100);
		}
		
		if (percentMinus != 0)
		{
			priceMinus -= startPrice * (percentMinus / 100);
		}
		
		value.map(function(v) {
			
			if (v.price > 0)
			{
				if (v.oper == "minus")
				{
					priceMinus -= v.price;
				}
				else
				{
					pricePlus += v.price;
				}
			}
		});
		
		pricePlus = Math.round(pricePlus);
		priceMinus = Math.round(priceMinus);
		
		if (
			(pricePlus > 0 || priceMinus < 0) && typeof PriceAnalysisSetOptEqPlusMinus === "function"
		) {
			PriceAnalysisSetOptEqPlusMinus(pricePlus, priceMinus);
		}
		
		if (typeof PriceConfiguratedUpdateValue === "function")
		{
			PriceConfiguratedUpdateValue();
		}
		
		this.handleClose();
	}
	
	handleChange(e) {
		
		const { startPrice, value } = this.state;
		
		const { UpdatePriceConfigPrice } = this.props;
		
		const id = parseInt(e.target.getAttribute("id"));
		const oper = e.target.getAttribute("oper");
		
		const obj = value.filter((x) => x.id == id && x.oper == oper)[0];
		
		obj.percent = parseInt(e.target.value);
		
		const price = this.updatePrice(value);
		
		UpdatePriceConfigPrice(price - startPrice);
		
		this.setState({ value });
	}
	
	handleCancel(e) {
		
		const startPrice = this.state.startPrice;
		
		const UpdatePriceConfigPrice = this.props.UpdatePriceConfigPrice;
		
		const savedValue = JSON.parse(this.state.savedValue);
		
		this.setState({ value: savedValue });
		
		UpdatePriceConfigPrice(this.updatePrice(savedValue) - startPrice);
		
		this.handleClose();
	}
	
	handleOpen() {
		
		if (!this.state.locked)
		{
			this.setState({
				modalOpen: true,
				savedValue: JSON.stringify(this.state.value)
			});
		}
	}
	
	handleClose = () => this.setState({ loading: false, modalOpen: false, savedValue: "" })
	
	handleEmbeddedMinusOpen = () => this.setState({ embeddedModalMinusOpen: true })
	
	handleEmbeddedMinusClose = () => this.setState({
		embeddedModalMinusOpen: false, embeddedButtonValue: 0, embeddedFieldError: false
	})
	
	handleEmbeddedPlusOpen = () => this.setState({ embeddedModalPlusOpen: true })
	
	handleEmbeddedPlusClose = () => this.setState({
		embeddedModalPlusOpen: false, embeddedButtonValue: 0, embeddedFieldError: false
	})
	
	tableRow(row) {
		
		let content;
		
		const color = row.oper == "minus" ? "red" : "green";
		const classColor = (row.percent > 0 || row.price > 0) ? color : "";
		const operator = row.oper == "minus" ? "-" : "+";
		
		if (typeof row.percent !== "undefined")
		{
			const inputRange = <input type="range" id={row.id} oper={row.oper} min={0} max={10}
				value={row.percent} onChange={this.handleChange} style={{width: "100%"}} />
			
			content =
			<Table.Row key={row.id}>
				<Table.Cell width={8} style={{ textAlign: "right" }}>{row.label}</Table.Cell>
				<Table.Cell>
					<Grid columns="equal" style={{paddingTop: "5px"}}>
						<Grid.Column width={2}>
							<Header size="tiny" style={{paddingTop: "3px"}} className={classColor}>
								{row.percent > 0 ? operator : ""}{row.percent}%
							</Header>
						</Grid.Column>
						<Grid.Column width={14}>{inputRange}</Grid.Column>
					</Grid>
				</Table.Cell>
			</Table.Row>;
		}
		else if (typeof row.price !== "undefined")
		{
			const deleteItem = this.deleteItem;
			
			content =
				<Table.Row key={row.id}>
					<Table.Cell width={8} style={{ textAlign: "right" }}>{row.label}</Table.Cell>
					<Table.Cell width={6} className={classColor}>
						<Header size="tiny" style={{paddingTop: "3px"}} className={classColor}>
							{row.price > 0 ? operator : ""}{row.price}{text.cur}
						</Header>
					</Table.Cell>
					<Table.Cell width={2}>
						<Button compact circular size="mini" icon="delete" color="red"
							className="right floated" id={row.id} onClick={deleteItem} />
					</Table.Cell>
				</Table.Row>;
		}
		
		return content;
	}
	
	submitOnEnter(e) {
		
		const { embeddedButtonValue, embeddedButtonLabelValue } = this.state;
		
		const { handleEmbeddedConfirmation } = this;
		
		const disabled = embeddedButtonLabelValue.trim() == "" || (embeddedButtonValue > 0 ? false : true);
		
		if (!disabled) handleEmbeddedConfirmation({ target: e.currentTarget });
	}
	
	updateButton(e) {
		
		let value = e.target.value;
		
		const rawValueLength = value.length;
		
		value = parseInt(value);
		
		const differentLengths = rawValueLength > 0 && rawValueLength != value.toString().length;
		
		const error = value > 999999 || value < 1 || isNaN(value) || differentLengths;
		
		if (error)
		{
			value = 0;
		}
		
		//console.log("value", value);
		
		this.setState({ embeddedButtonValue: value, embeddedFieldError: error });
	}
	
	modalEmbeddedElement(oper) {
		
		const updateButtonLabel = e => {
			
			this.setState({ embeddedButtonLabelValue: e.target.value ? e.target.value : "" });
		}
		
		let { embeddedButtonValue, embeddedFieldError, embeddedButtonLabelValue } = this.state;
		
		const {
			handleEmbeddedMinusClose, handleEmbeddedPlusClose, submitOnEnter, updateButton
		} = this;
		
		const closeHandle = oper == "minus" ? handleEmbeddedMinusClose : handleEmbeddedPlusClose;
		const color = oper == "minus" ? "red" : "green";
		
		const buttonValue = embeddedButtonValue > 0 ? embeddedButtonValue : 0;
		
		const operator = buttonValue > 0 ? (oper == "minus" ? "-" : "+") : "";
		const content = operator + buttonValue + text.cur;
		const disabled = embeddedButtonLabelValue.trim() == "" || (buttonValue > 0 ? false : true);
		
		return (
			<Modal.Content scrolling className="no-print">
				<Modal.Description>
					<Form onSubmit={submitOnEnter} oper={oper}>
						<Form.Field>
							<label>{text.justification}</label>
							<Input
								required
								name="label"
								placeholder={text.justification}
								onChange={updateButtonLabel}
							/>
						</Form.Field>
						<Input
							fluid
							required
							name="price"
							label={text.cur}
							placeholder={text.price}
							onChange={updateButton}
							error={embeddedFieldError}
							style={{ paddingBottom: "20px" }}
						/>
						<Button type="button" onClick={closeHandle}>
							<Icon name="times circle" /> {text.cancel}
						</Button>
						<Button
							color={color}
							type="submit"
							content={content}
							disabled={disabled}
							icon="right chevron"
							labelPosition="right"
							className="right floated"
						/>
					</Form>
				</Modal.Description>
			</Modal.Content>
		);
	}
	
	handleEmbeddedConfirmation(e) {
		
		//console.log("Submitted");
		
		const { value } = this.state;
		
		const oper = e.target.getAttribute("oper");
		
		const id = Math.max.apply(Math, value.map(function(v) { return v.id })) + 1;
		
		value.push({
			oper: oper,
			id: id,
			label: e.target.label.value,
			price: parseInt(e.target.price.value)
		});
		
		this.setState({
			value, price: this.updatePrice(value), embeddedButtonValue: 0, embeddedFieldError: false
		});
		
		if (oper == "minus")
		{
			this.handleEmbeddedMinusClose();
		}
		else
		{
			this.handleEmbeddedPlusClose();
		}
	}
	
	deleteItem(e) {
		
		let {value} = this.state;
		
		const deleteId = value.map(v => v.id).indexOf(parseInt(e.target.id));
		
		if (deleteId >= 0)
		{
			value.splice(deleteId, 1);
			
			this.setState({value, price: this.updatePrice(value)});
		}
	}
	
	render() {
		
		let {
			valuation, value, savedValue, modalOpen, loading, embeddedModalMinusOpen,
			embeddedModalPlusOpen, locked
		} = this.state;
		
		let { price, optEq, priceConfig } = this.props;
		
		price = (price + optEq + priceConfig).formatMoney(0, ".", ",") + text.cur;
		
		const svgPriceLabel = document.getElementById("svg-price-label");
		
		if (svgPriceLabel)
		{
			svgPriceLabel.innerHTML = price;
		}
		
		//if (priceConfig < 0) loading = 1;
		
		if (!valuation)
		{
			const button = <Label as="a" color="green" size="large" content={price} tag />;
			
			return <Popup trigger={button} position="bottom right" on="click" size="small" content={text.noValuationNotice} />;
		}
		
		const hasChanges = JSON.stringify(value) != savedValue;
		
		const icon = loading == 1 || !valuation || locked ? "" : "pencil";
		
		const groupButton = <Label as="a" color="green" size="large" icon={icon}
			content={ loading == 1 ? <Loader className='workaround' size='mini' active /> : price }
			onClick={this.handleOpen} tag />;
		
		const newMinusButton =
			<Button fluid basic onClick={this.handleEmbeddedMinusOpen} negative>
				<Icon name="minus circle" /> {text.buttonMinus}
			</Button>;
		
		const newPlusButton =
			<Button fluid basic onClick={this.handleEmbeddedPlusOpen} positive>
				<Icon name="plus circle" /> {text.buttonPlus}
			</Button>;
		
		let tableRow = this.tableRow, tableMinus = [], tablePlus = [];
		
		value.map(function(obj) {
			
			if (typeof obj.percent !== "undefined")
			{
				if (obj.oper == "minus")
				{
					tableMinus.push(tableRow(obj));
				}
				else
				{
					tablePlus.push(tableRow(obj));
				}
			}
		});
		
		let tableUserMinus = [], tableUserPlus = [];
		
		value.map(function(obj) {
			
			if (typeof obj.price !== "undefined")
			{
				if (obj.oper == "minus")
				{
					tableUserMinus.push(tableRow(obj));
				}
				else
				{
					tableUserPlus.push(tableRow(obj));
				}
			}
		});
		
		return (
			<Modal size="small" closeOnEscape={false} closeOnDimmerClick={!hasChanges} open={modalOpen}
				trigger={groupButton} onClose={this.handleClose} className="no-print"
			>
				<Modal.Header>{text.morePrices}</Modal.Header>
				<Modal.Content scrolling>
					<Modal.Description>
						{ loading == 1 ? <Loader className='workaround' active inline='centered' /> :
							<React.Fragment>
								<Divider horizontal style={{ marginTop: 0 }}>
									<Header as="h4">
										<Icon color="grey" name="minus square" />{text.finalPriceMinus}
									</Header>
								</Divider>
								<Table compact definition><Table.Body>{tableMinus}</Table.Body></Table>
								<Table compact definition><Table.Body>{tableUserMinus}</Table.Body></Table>
								<Modal
									size="mini"
									className="no-print"
									trigger={newMinusButton}
									closeOnDimmerClick={false}
									closeOnEscape={false}
									open={embeddedModalMinusOpen}
									onClose={this.handleEmbeddedMinusClose}
								>
									<Modal.Header>{text.newMinusPrice}</Modal.Header>
									{this.modalEmbeddedElement("minus")}
								</Modal>
								<Divider horizontal style={{ marginTop: "30px" }}>
									<Header as="h4">
										<Icon color="grey" name="plus square" />{text.finalPricePlus}
									</Header>
								</Divider>
								<Table compact definition><Table.Body>{tablePlus}</Table.Body></Table>
								<Table compact definition><Table.Body>{tableUserPlus}</Table.Body></Table>
								<Modal
									size="mini"
									className="no-print"
									trigger={newPlusButton}
									closeOnDimmerClick={false}
									closeOnEscape={false}
									open={embeddedModalPlusOpen}
									onClose={this.handleEmbeddedPlusClose}
								>
									<Modal.Header>{text.newPlusPrice}</Modal.Header>
									{this.modalEmbeddedElement("plus")}
								</Modal>
							</React.Fragment>
						}
					</Modal.Description>
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={this.handleCancel} className="left floated"
						style={{ marginLeft: "7px", marginTop: "8px" }}>
						<Icon name="times circle" /> {text.cancel}
					</Button>
					<Button disabled={!hasChanges || loading == 2} onClick={this.handleSaveBeforeClose}
						labelPosition="right" color="green" icon="right chevron" content={price}
						style={{ margin: "8px" }} loading={loading == 2} />
				</Modal.Actions>
			</Modal>
		);
	}
}

class CarReportControlStrip extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			canValuate: props.canValuate,
			hasAvailableValuations: props.hasAvailableValuations,
			valuation: props.valuation,
			valuationId: props.valuationId,
			plate: props.plate,
			disabled: props.disabled,
			price: props.price,
			contentEditable: false,
			optEq: 0,
			priceConfig: 0
		};
		
		this.UpdateOptEqPrice = this.UpdateOptEqPrice.bind(this);
		this.UpdatePriceConfigPrice = this.UpdatePriceConfigPrice.bind(this);
	}
	
	UpdateOptEqPrice(optEq) {
		
		this.setState({ optEq });
	}
	
	UpdatePriceConfigPrice(priceConfig) {
		
		this.setState({ priceConfig });
	}
	
	render() {
		
		const {
			canValuate, hasAvailableValuations, valuation, valuationId, plate,
			disabled, price, optEq, priceConfig, contentEditable
		} = this.state;
		
		const { UpdateOptEqPrice, UpdatePriceConfigPrice } = this;
		
		const { admin, selectedEquipment } = this.props;
		
		const contentEditableAction = () => {
			
			this.setState({ contentEditable: !this.state.contentEditable });
			
			ContentEditable();
		};
		
		return (
			<div>
				{valuation ? (
					<span>
						<PlateAttach valuationId={valuationId} plate={plate} />
						<OptEq
							price={price}
							optEq={optEq}
							priceConfig={priceConfig}
							UpdateOptEqPrice={UpdateOptEqPrice}
						/>
					</span>
				) : null}
				{/*<Button
					compact
					basic
					size="small"
					icon="print"
					onClick={() => window.print()}
					color="black"
					className="no-print"
				/>*/}
				{admin && <Button
					compact
					basic={!contentEditable}
					size="small"
					icon="edit"
					onClick={contentEditableAction}
					color="black"
					className="no-print"
				/>}
				<EstimateButton
					canValuate={canValuate}
					hasAvailableValuations={hasAvailableValuations}
				/>
				<PriceConfigurator
					price={price}
					optEq={optEq}
					priceConfig={priceConfig}
					UpdatePriceConfigPrice={UpdatePriceConfigPrice}
					valuation={valuation}
				/>
			</div>
		);
	}
}

class OptEqSelected extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = { equipment: [] };
	}
	
	componentDidMount() {
		
		window["OptEqSelectedSetEquipment"] = (equipment) => {
			
			this.setState({ equipment });
		};
	}
	
	render() {
		
		const equip = this.state.equipment;
		
		return (
			<OptEqContent equip={equip} opentag="opteq" locked />
		);
	}
}

class PriceConfigurated extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = { key: 0, equipment: [] };
		
		this.updateValue = this.updateValue.bind(this);
	}
	
	getElement(key, label, price) {
		
		return {
			code: key,
			label: label,
			price: price
		};
	}
	
	updateValue() {
		
		if (typeof priceConfiguratorGetStatus != "function")
		{
			return false;
		}
		
		let { key } = this.state;
		
		const { startPrice, value } = priceConfiguratorGetStatus();
		
		const getElement = this.getElement;
		
		var percent = 0, equipment = [];
		
		value.map(function(v) {
			
			if (v.percent > 0)
			{
				const price = startPrice * (v.percent / 100) * (v.oper == "minus" ? -1 : 1);
				
				equipment.push(getElement(key, v.label, price));
			}
			else if (v.price > 0)
			{
				equipment.push(getElement(key, v.label, (v.oper == "minus" ? -v.price : v.price)));
			}
			
			key++;
		});
		
		this.setState({ equipment, key });
	}
	
	componentDidMount() {
		
		window["PriceConfiguratedUpdateValue"] = () => {
			this.updateValue();
		};
		
		this.updateValue();
	}
	
	render() {
		
		const {equipment} = this.state;
		
		return (
			<OptEqContext.Provider value={optEqGetGlobalObj()}>
				<OptEqContent title={text.otherMinusPlusValues} equip={equipment} opentag="price" locked />
			</OptEqContext.Provider>
		);
	}

}

if (!document.getElementById("loading-screen"))
{
	window["text"] = {
		cur: "€",
		registerSuccess: 'Η εγγραφή σας έγινε επιτυχώς! Παρακαλούμε μπείτε στο email σας και πατήστε το κουμπί στο email που σας στείλαμε, για να επιβεβαιώσετε τον λογαριασμό σας.',
		loading: '<div class="loading">⦿ Γίνεται φόρτωση...</div>',
		loadingText: 'Γίνεται φόρτωση',
		extraEquipment: 'Προαιρετικός Εξοπλισμός',
		noExtraEquipment: 'Δεν υπάρχει προαιρετικός εξοπλισμός',
		equipment: 'Ο εξοπλισμός',
		included: 'περιλαμβάνεται',
		equipmentObligatory: 'πρέπει υποχρεωτικά να επιλεγεί μαζί με τον εξοπλισμό',
		equipmentExclude: 'δεν μπορεί να περιλαμβάνεται στον εξοπλισμό',
		equipmentIncluded: 'περιλαμβάνεται δωρεάν στον εξοπλισμό',
		includes: 'Περιλαμβάνει',
		noPackageContent: 'Δεν υπάρχουν δεδομένα για την συγκεκριμένη περίοδο',
		noValuationNotice: 'Για να μπορέσετε να επεξεργαστείτε την τιμή, πρέπει πρώτα να κάνετε εκτίμηση αξίας του οχήματος.',
		noRemainingEstimations: "There are no remaining estimations for your account.",
		noPricesAvailable: "There are no values ​​available for vehicle evaluation.",
		errorOnSave: 'Η αποθήκευση δεν μπόρεσε να πραγματοποιηθεί',
		errorOnLoad: 'Η φόρτωση περιεχομένου δεν μπόρεσε να πραγματοποιηθεί',
		finalPriceAnalysis: 'Ανάλυση Τελικής Υπολειμματικής Αξίας',
		finalPriceRetail: 'Αξία Λιανικής',
		finalPriceTrade: 'Αξία Χονδρικής',
		finalPrice: 'Υπολειμματική Αξία',
		finalPriceKm: 'Ρύθμιση Χιλιομέτρων',
		finalPriceEq: 'Επιπλέον Εξοπλισμοί',
		finalPriceMinus: 'Λοιπές Μειώσεις',
		finalPricePlus: 'Πρόσθετες Αξίες',
		finalPriceFinal: 'Τελική Υπολειμματική Αξία',
		otherMinusPlusValues: 'Λοιπές Μειώσεις / Πρόσθετες Αξίες',
		carNotEditable: 'Selected car is no longer editable',
		packageContents: "Περιεχόμενα Πακέτου",
		cancel: "Ακύρωση",
		close: "Κλείσιμο",
		edpr1: "Δεύτερο Χέρι και Άνω",
		edpr2: "Φθορές Εξωτερικά",
		edpr3: "Φθορές Εσωτερικά",
		edpr4: "Τρακαρισμένο",
		edpr5: "Βιβλίο Service",
		edpr6: "Φθορές Ελαστικών",
		edpr7: "Άριστη Κατάσταση",
		buttonMinus: "Άλλη Μείωση Αξίας",
		buttonPlus: "Άλλη Πρόσθετη Αξία",
		morePrices: "Συμπληρωματικές Αξίες",
		newMinusPrice: "Νέα Μείωση Αξίας",
		newPlusPrice: "Νέα Πρόσθετη Αξία",
		category1: "Exterior",
		category2: "Interior",
		category3: "Navigator",
		category5: "Systems",
		category6: "Other",
		allEquipment: "All Equipment",
		valuation: "Εκτίμηση",
		noHistory: "Δεν υπάρχουν αποτελέσματα",
		noResults: "No results found",
		consumption: "Consumption",
		norm: "Norm",
		transmission: "Transmission",
		weight: "Weight",
		battery: "Battery",
		generalSearch: "Αναζήτηση..",
		emptyFieldError: "Field can't be empty",
		justification: "Justification",
		price: "Price",
		history: "Ιστορικό",
		notverified: "Your e-mail account is not verified."
	};
	
	window["GetAttributeFromEvent"] = function GetAttributeFromEvent(e, attribute) {
		const preventReact = true;
	
		var t = e.target;
	
		while (
			t != null &&
			typeof t.getAttribute === "function" &&
			!t.getAttribute(attribute) &&
			(
				!preventReact ||
				(
					preventReact &&
					!t.getAttribute("role")
				)
			)
		) {
			t = t.parentNode;
		}
	
		if (
			t != null &&
			typeof t.getAttribute === "function"
		) {
			return t.getAttribute(attribute);
		}
	
		return false;
	}
	
	ReactDOM.render(
		<CarReportControlStrip
			price={51540}
			disabled={false}
			valuation={true}
			valuationId={false}
			plate="ioi1714"
			canValuate={true}
			hasAvailableValuations={true}
			admin={true}
		/>,
		document.getElementById("car-report-control-strip")
	);
	
	ReactDOM.render(<OptEqSelected />, document.getElementById("opteq-selected"));
	
	const testPriceObj = {
		carMultiplier: 0.91,
		dateValid: "12/2017",
		kmValid: 1,
		equipmentRetail: 0,
		equipmentTrade: 0,
		finalRetail: 51540,
		finalRetailReference: 51540,
		finalTrade: 46901,
		dateRetail: 2034,
		dateTrade: 1851,
		kmRetail: 702,
		kmTrade: 639,
		otherAddRetail: 0,
		otherAddTrade: 0,
		otherMinusRetail: 0,
		otherMinusTrade: 0,
		remainingRetail: 48804,
		remainingTrade: 44411,
		tradeMultiplier: 0.3
	};
	
	ReactDOM.render(<PriceAnalysis price={testPriceObj} />, document.getElementById("price-analysis"));
	
	ReactDOM.render(<PriceConfigurated />, document.getElementById("price-configurated"));
	
	const image = [
		'https://sgas.gr/services/private/car_image/P/p0545310.jpg',
		'https://sgas.gr/services/private/car_image/P/p0545311.jpg',
		'https://sgas.gr/services/private/car_image/P/p0545312.jpg'
	];
	
	ReactDOM.render(<CarImage image={image} />, document.getElementById("car-image"));
	
	ReactDOM.render(<ButtonAllHistory />, document.getElementById("button-all-history"));
	
	ReactDOM.render(<GeneralSearch />, document.getElementById("general-search"));
	
	const testReportData = {
		cc: 2979,
		hp: 431,
		acceleration: 5.3,
		fuel: "Βενζίνη αμόλυβδη",
		co2: 209,
		consumption: 9.1,
		emission: "Euro 6",
		transmission: "Manual",
		gear: 6,
		weight: 1950,
		alloywheels: true,
		electric: true
	};
	
	ReactDOM.render(<TechnicsReportShort data={testReportData} />, document.getElementById("technics-report-short"));
	
	ReactDOM.render(<LoginForm />, document.getElementById("login-form"));
}
else
{
	window["React"] = React;
	window["ReactDOM"] = ReactDOM;
	window["OptEq"] = OptEq;
	window["EstimateButton"] = EstimateButton;
	window["PriceConfigurator"] = PriceConfigurator;
	window["OptEqSelected"] = OptEqSelected;
	window["PriceAnalysis"] = PriceAnalysis;
	window["PriceConfigurated"] = PriceConfigurated;
	window["CarImage"] = CarImage;
	window["ButtonAllHistory"] = ButtonAllHistory;
	window["TechnicsReportShort"] = TechnicsReportShort;
	window["GeneralSearch"] = GeneralSearch;
	window["PlateAttach"] = PlateAttach;
	window["LoginForm"] = LoginForm;
	window["CarReportControlStrip"] = CarReportControlStrip;
}